/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Form, Select } from 'antd'
import _ from 'lodash'
import { observer } from 'mobx-react'
import { compose } from 'recompose'
import { 
	GENERIC_LOOKUP, CRIME_TYPE
} from '../../../../constants/lookup'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { form } = this.props
		const { getFieldDecorator, getFieldValue } = form
        
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col md={6} sm={24}>
						<Form.Item label="4P's Member">
							{ getFieldDecorator('experienced_hunger', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Victim of Crime?'>
							{ getFieldDecorator('victim_of_crime', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Type of Crime'>
							{ getFieldDecorator('type_of_crime', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select 
									disabled={getFieldValue('victim_of_crime') && 
										(_.isEqual(getFieldValue('victim_of_crime'), 'No') || _.isEqual(getFieldValue('victim_of_crime'), 'Not applicable'))}
									placeholder='Select Type of Crime'
								>
									{
										CRIME_TYPE.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Other crime'>
							{ getFieldDecorator('other_crime', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input 
									disabled={((getFieldValue('type_of_crime') && getFieldValue('type_of_crime') !== 'Other crimes (specify)') ||
									(getFieldValue('victim_of_crime') && 
										(_.isEqual(getFieldValue('victim_of_crime'), 'No') || _.isEqual(getFieldValue('victim_of_crime'), 'Not applicable'))))}
									placeholder='Enter crime'
								/>
							)}
						</Form.Item>
					</Col>
					<Col md={6} sm={24}>
						<Form.Item label='Living?'>
							{ getFieldDecorator('is_alive', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Select placeholder='Select Status'>
									<Select.Option value={1}>Alive</Select.Option>
									<Select.Option value={0}>Deceased</Select.Option>
								</Select>
							)}
						</Form.Item>
					</Col>
				</Row>
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
